export const constructPatchDataByKey = (patchPrefixData, patchOptionsData, optionDataKey, prefixDataKey) => {
    const patchOptionsDataDeepCopy = JSON.parse(JSON.stringify(patchOptionsData));
    const patchPrefixDataDeepCopy = JSON.parse(JSON.stringify(patchPrefixData));

    const isConfiguratorOptionData = Boolean(patchOptionsDataDeepCopy?.[optionDataKey]?.length)
    const isConfiguratorPrefixData = Boolean(patchPrefixDataDeepCopy?.[prefixDataKey]?.length)

    if (isConfiguratorOptionData && isConfiguratorPrefixData) {
        patchOptionsDataDeepCopy[optionDataKey].map(inp =>
            patchPrefixDataDeepCopy[prefixDataKey].forEach(x => {
                if (x.PATCH === inp.PATCH) {
                    inp.PATCH = x.PREFIX + inp.PATCH
                }
                if (x.PATCH === inp.PATCH__1) {
                    inp.PATCH__1 = x.PREFIX + inp.PATCH__1
                }
                if (x.PATCH === inp.PATCH__2) {
                    inp.PATCH__2 = x.PREFIX + inp.PATCH__2
                }
                if (x.PATCH === inp.PATCH__3) {
                    inp.PATCH__3 = x.PREFIX + inp.PATCH__3
                }
            })
        )
    }

    return patchOptionsDataDeepCopy
}